/* tslint:disable */
/* eslint-disable */
/**
 * AdServer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { GameFromJSON, GameToJSON, } from '../models/index';
/**
    * Converts a number to a padded string
    * @param num The number to stringify
    * @param size Number of total digits
    */
function pad(num, size) {
    let negative = num < 0;
    if (negative) {
        num *= -1;
    }
    let numString = num.toString();
    while (numString.length < size)
        numString = "0" + numString;
    return (negative ? "-" : "") + numString;
}
/**
    * Returns a date in the RFC3339 format, e.g.: 2016-01-19T15:21:32.59+02:00
    * @param dateTime
    */
export function toRFC3339(dateTime) {
    let rfcWithoutTimeoffset = `${dateTime.getFullYear()}-${pad(dateTime.getMonth() + 1, 2)}-${pad(dateTime.getDate(), 2)}T${pad(dateTime.getHours(), 2)}:${pad(dateTime.getMinutes(), 2)}:${pad(dateTime.getSeconds(), 2)}${dateTime.getMilliseconds() != 0 ? "." + pad(dateTime.getMilliseconds(), 3) : ""}`;
    let timeOffsetString;
    let to = dateTime.getTimezoneOffset() * -1;
    let toh = Math.floor(to / 60);
    let tom = to % 60;
    if (tom < 0) {
        tom *= -1;
    }
    timeOffsetString = pad(toh, 2) + ":" + pad(tom, 2);
    return rfcWithoutTimeoffset + (toh > 0 ? "+" : "") + timeOffsetString;
}
/**
 *
 */
export class CompanyApi extends runtime.BaseAPI {
    /**
     * Retrieves the company info for the given id
     */
    async companyCompanyIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError('companyId', 'Required parameter "companyId" was null or undefined when calling companyCompanyIdGet().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/company/{companyId}`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GameFromJSON));
    }
    /**
     * Retrieves the company info for the given id
     */
    async companyCompanyIdGet(requestParameters, initOverrides) {
        const response = await this.companyCompanyIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
